<footer class="app-footer">
  <div class="footer-container">
    <div class="footer-section">
      <h4>{{ title }}</h4>
      <p>&copy; 2025 {{ title }}. Todos los derechos reservados.</p>
    </div>
    <div class="footer-section">
      <h4>Company</h4>
      <ul>
        <li><a routerLink="/home">Acerca de nosotros</a></li>
        <li><a routerLink="/home">Noticias</a></li>
      </ul>
    </div>
    <div class="footer-section">
      <h4>Support</h4>
      <ul>
        <li><a routerLink="/help">Preguntas frecuentes</a></li>
        <li><a routerLink="/contact">Contáctenos</a></li>
        <li><a routerLink="/privacy">Políticas de privacidad</a></li>
      </ul>
    </div>
    <div class="footer-section social">
      <h4>Follow Us</h4>
      <a href="#" target="_blank" aria-label="Twitter">twitter</a>
      <a href="#" target="_blank" aria-label="LinkedIn">linkedin</a>
    </div>
  </div>
</footer>
